export var permissions = JSON.parse(localStorage.getItem('permissions'));

export const hasPermission = (permission) => {
  return permissions?.includes(permission);
};